import { HttpClient, RequestParams } from "./base/BaseHttpClient";
import { BusinessGoalResultDto } from "./contracts/models";

export class BusinessGoalDataResultsApi<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags BusinessGoalDataResults
   * @name List
   * @request GET:/api/business-goal-data-results
   * @response `200` `(BusinessGoalResultDto)[]` OK
   */
  list = (params: RequestParams = {}) =>
    this.http
      .request<BusinessGoalResultDto[], any>({
        path: `/api/business-goal-data-results`,
        method: "GET",
        credentials: "include",
        format: "json",
        ...params,
      })
      .then((m) => m.data);
}
